module.exports = __webpack_public_path__ + "static/media/1009228.9593da5e.png";